module.exports = __webpack_public_path__ + "static/paris-003-cd40b586c226f1c9e701ad6fc738729d.jpg";